<template>
    <component :is="component" :session-id="sessionId" @game-session-done="onGameSessionDone" />
</template>

<script>
import upperFirst from 'lodash-es/upperFirst';
import gameHelper from '@/modules/games-shared/game-helper';

export default {
    props: {
        gameId: {
            type: String,
            required: true
        },
        levelIndex: {
            type: Number
        },
        sessionId: {
            type: String,
            required: true
        }
    },
    computed: {
        component() {
            return () => import('@/modules/game-' + this.gameId + '/App');
        }
    },
    methods: {
        onGameSessionDone(signal) {
            const session = gameHelper.sessions[this.sessionId];
            const isLevelSession = this.levelIndex !== undefined;
            if (session.quizReport) {
                if (signal === 'success') {
                    if (isLevelSession && session.quizReport.stars > 0) {
                        this.$store.dispatch(`moduleGame${upperFirst(this.gameId)}/updateLevel`, {
                            levelIndex: this.levelIndex,
                            data: {
                                stars: session.quizReport.stars,
                                bestTime: session.quizReport.timeUsed
                            }
                        });
                    }

                    if (session.testName !== 'memoryOnboardingTestA' && session.testName !== 'memoryOnboardingTestB') {
                        // NOTE: all sessions that ends with 'success' will produce a brain date
                        this.$store.dispatch('moduleApp/registerBraindate', {
                            context: 'game',
                            lifeskillNumber: '02',
                            gameId: this.gameId,
                            levelIndex: this.levelIndex, // NOTE: Can be undefined
                            activity: 'quiz'
                        });
                    }
                }
                if (session.challengeId) {
                    this.$store.dispatch('moduleSocial/createActivity', { challengeId: session.challengeId });
                }

                if (session.testName) {
                    if (session.testName === 'memoryOnboardingTestA') {
                        const alreadyDone = !!this.$store.state.moduleMemogenius.settings.memoryOnboardingTestA;
                        if (!alreadyDone) {
                            this.$store.dispatch('moduleApp/registerBraindate', {
                                context: 'memoryiq',
                                lifeskillNumber: '02',
                                activity: 'memoryOnboardingTestA'
                            });
                        }
                    }
                    this.$store.dispatch('moduleMemogenius/storeMemoryOnboardingResult', {
                        testName: session.testName,
                        data: {
                            totalCount: session.options.numberOfItems,
                            correctCount: session.quizReport.items.filter(item => item.score === 1).length,
                            timeUsed: session.quizReport.timeUsed + (session.memorizeReport.timeUsed || 0)
                        }
                    });
                }
            }

            if (signal === 'exit') {
                if (session.exitUrl) {
                    return this.$router.push(session.exitUrl);
                } else if (isLevelSession) {
                    return this.$router.push({
                        name: 'MemogeniusGame-Levels'
                    });
                }
            } else if (signal === 'success') {
                if (session.resultUrl) {
                    return this.$router.push(session.resultUrl);
                } else if (isLevelSession) {
                    return this.$router.push({
                        name: 'MemogeniusGame-LevelSuccess',
                        params: {
                            levelIndex: this.levelIndex,
                            sessionId: this.sessionId
                        }
                    });
                }
            } else if (signal === 'fail') {
                if (session.resultUrl) {
                    return this.$router.push(session.resultUrl);
                } else if (isLevelSession) {
                    return this.$router.push({
                        name: 'MemogeniusGame-LevelFail',
                        params: {
                            levelIndex: this.levelIndex,
                            sessionId: this.sessionId
                        }
                    });
                }
            }

            return this.$router.push({
                name: 'DashboardHomeView'
            });
        }
    }
};
</script>
